module.exports = __webpack_public_path__ + "static/media/data-recycle-selected.9294d759.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/data-recycle-selected.svg
// module id = 386
// module chunks = 0